import React from 'react';
import {useDispatch, useSelector} from "react-redux"
import {logIn, grabToken, setPassword, setPasswordType, setUsername} from "../../Features/Auth/authSlice"
import { useNavigate} from "react-router-dom"
import { Animate} from "react-simple-animate";
import SignUpQuery from "./SignUpQuery";
import ResetPasswordQuery from "../structure/Passwords/ResetPasswordQuery";

export default function LoginForm({setKnowsPassword}) {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {username, password, passwordType, logInIsPending, logInIsError} = useSelector((state) => state.auth);

    const handleSubmit = async(e) =>{
        e.preventDefault()

        const userData = {
            username,
            password
        }

        await dispatch(grabToken(userData))
        await dispatch(logIn(userData))

        navigate("/")
        dispatch(setUsername("Email"))
        dispatch(setPassword("Password"))
        dispatch(setPasswordType("text"))
    }

    const inputStyle = "bg-purple-dashboard focus:outline-none focus:border-light-pink border-dark-pink rounded-lg border-2 h-14 px-4 py-2"

    return (
        <form className="lg:col-start-1 col-start-2 lg:col-end-13 col-end-12 row-start-3 row-end-13 text-2xl text-white ">
            <Animate play start={{opacity: 0}} end={{opacity: 1, display: "flex", flexDirection: "column", gap: "1rem" }} duration={0.7} >
                <div className=" text-lg ">Welcome back!</div>

                <input
                    type={"email"}
                    placeholder={username}
                    value={username}
                    onClick={() => {if(username === "Email"){dispatch(setUsername(""))} }}
                    onChange={e => dispatch(setUsername(e.target.value))}
                    onBlur={() => {if(username === ""){ dispatch(setUsername("Email"))} }}
                    className={inputStyle}
                />

                <input
                    type={passwordType}
                    placeholder={password}
                    value={password}
                    onFocus={() => { if(password === "Password" && passwordType === "text"){dispatch(setPassword("")); dispatch(setPasswordType("password"))}}}
                    onChange={e => dispatch(setPassword(e.target.value))}
                    onBlur={() => {if(password === ""){ dispatch(setPassword("Password")); dispatch(setPasswordType("text"))} }}
                    className={inputStyle}
                />

                <button onClick={handleSubmit} className="bg-gold-accent hover:bg-gold-accent-hover text-white h-14 px-4 py-2 rounded-lg">
                    {logInIsPending ? "Logging in..." : logInIsError ? "Please try again" : "Log In"}
                </button>
                <SignUpQuery/>
                <ResetPasswordQuery setKnowsPassword={setKnowsPassword}/>
            </Animate>
        </form>
    )
}